import Button from "../../Components/Button/Button";
import Text from "../../Components/Text/Text";
import HeroImage from "../../assets/images/home-hero-bg.png";
import { ReactComponent as RightTriangleSvg } from "../../assets/svgs/right-triangle.svg";

export default function IntroductionSection() {
  return (
    <section className="relative">
      <img
        className="w-full min-h-[800px] h-screen object-cover pointer-events-none"
        src={HeroImage}
        alt="AgileLab"
      />

      <div className="container absolute top-24 sm:top-1/4 lg:top-1/2 left-1/2 -translate-x-1/2 lg:-translate-y-1/2 px-4">
        <Text type="h1" size="d5" className="animate-fade-in-left text-grey-950">
          Build Software That Drives 
          <br />
          Real Business Success 
        </Text>
        <Text type="h1" size="subD5" className="animate-fade-in-left mt-6">
          Your Success is The Only Measure
        </Text>
        <Text
          type="p"
          size="normal"
          className="animate-fade-in-left max-w-[624px] mt-8"
        >
          We help enterprises and innovation teams deliver high-stakes software with clarity, speed, and alignment.
        </Text>
        <Text
          type="p"
          size="normal"
          className="animate-fade-in-left max-w-[652px] my-8"
        >
          Through strategy-led discovery, custom development, and long-term partnerships, we turn complex initiatives into confident execution.
        </Text>

        <Button path="contact-us" className="animate-fade-in-left inline-block text-xl text-center max-sm:text-base">
          LET’S BUILD SMARTER SOFTWARE
        </Button>
      </div>

      <RightTriangleSvg className="transition-all absolute bottom-0 fill-white animate-raise-up w-full" />
    </section>
  );
}
